import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const languages = {
  es: { code: 'es', name: 'Español', flag: '🇪🇸' },
  fr: { code: 'fr', name: 'Français', flag: '🇫🇷' },
  en: { code: 'en', name: 'English', flag: '🇬🇧' },
  pt: { code: 'pt', name: 'Português', flag: '🇧🇷' },
};

export const translations = {
  fr: {
    // Header
    nav: {
      advantages: 'Avantages',
      applications: 'Capteurs multifonctionnels',
      solutions: 'Solutions',
      whyChoose: 'Notre engagement',
      products: 'Produits',
      software: "Logiciel d'installation",
      videos: 'Vidéos SMARTMICRO',
      faq: 'FAQ',
      contact: 'Contact',
      contactUs: 'Nous Contacter',
    },
    // Hero
    hero: {
      companyName: 'Smart Systems Paraguay SA',
      badge: 'Distributeur officiel SMARTMICRO',
      title: 'Capteurs Radar Intelligents',
      subtitle: 'pour la Gestion du Trafic',
      description: "Découvrez la technologie de détection radar la plus avancée au monde pour optimiser le flux de circulation, améliorer la sécurité routière et construire des villes plus intelligentes.",
      cta: 'Découvrir nos solutions',
      trustText: 'Technologie utilisée par des villes du monde entier',
    },
    // Advantages
    advantages: {
      badge: 'Pourquoi le radar ?',
      title: 'Les avantages de la technologie',
      titleHighlight: ' SMARTMICRO',
      subtitle: "Une solution de détection supérieure qui surpasse les technologies traditionnelles dans toutes les conditions.",
      items: [
        { title: 'Fiabilité Tous Temps', description: "Fonctionne parfaitement sous la pluie, la neige, le brouillard, de jour comme de nuit. La technologie radar n'est pas affectée par la saleté, le smog ou les tempêtes de sable." },
        { title: 'Protection de la Vie Privée', description: "Contrairement aux caméras, les capteurs radar ne capturent ni visages ni plaques d'immatriculation, garantissant une confidentialité totale des usagers de la route." },
        { title: 'Installation Simple', description: "Montage non-intrusif sur l'infrastructure existante : poteaux d'éclairage, feux de circulation. Aucune modification de la chaussée nécessaire." },
        { title: 'Précision Ultra-Haute', description: "Technologie 4D/UHD permettant de classifier 7 types de véhicules avec une précision de détection supérieure à 98%." },
        { title: 'Données en Temps Réel', description: "Transmission instantanée des données de trafic pour une gestion adaptative et des décisions immédiates." },
        { title: 'Réduction CO2', description: "Optimisation du flux de circulation réduisant les embouteillages et les temps d'attente, contribuant à la diminution des émissions." },
      ],
      comparison: {
        title: 'Radar vs Caméras traditionnelles',
        description: "La technologie radar offre une fiabilité inégalée là où les caméras échouent : obscurité totale, conditions météo extrêmes, et respect total de la vie privée.",
        stats: [
          { value: '100%', label: 'Fonctionnel de nuit' },
          { value: 'IP67', label: 'Étanchéité totale' },
          { value: '-40°C', label: 'à +85°C' },
          { value: '0%', label: 'Données personnelles' },
        ],
      },
    },
    // Stats
    stats: [
      { value: 'ISO 9001', label: 'Certifié' },
      { value: '27+', label: "Années d'expérience" },
      { value: '98.4%', label: 'Précision de détection' },
      { value: '24/7', label: 'Fonctionnement continu' },
    ],
    // Applications
    applications: {
      badge: 'Capteurs multifonctionnels',
      title: 'Capteurs',
      titleHighlight: ' multifonctionnels',
      subtitle: "Un seul capteur SMARTMICRO peut être utilisé pour de multiples applications, offrant une flexibilité et un retour sur investissement inégalés.",
      learnMore: 'En savoir plus',
      items: [
        { title: 'Gestion des intersections', description: "", features: ["Détection combinée de stop bar et file d'attente", 'Objets arrêtés et en mouvement', "Longueur des files d'attente", 'Smartcities'] },
        { title: 'Gestion des autoroutes', description: "", features: ['Comptage et classification du trafic', 'Détection d\'incidents', 'Conduite à contre-sens', 'Ramp metering', 'Tunnel'] },
        { title: 'Applications de contrôle', description: "", features: ['Contrôle des feux rouges', 'Contrôle de vitesse', 'Contrôle de vitesse portable', 'Contrôle de vitesse mobile'] },
      ],
    },
    // Solutions
    solutions: {
      badge: 'Solutions',
      title: 'Solutions',
      items: [
        { title: 'Villes', features: ['Détection pour feux de circulation', 'Présence', 'Comptage / Vitesse / Catégorisation', 'Congestion / Files'] },
        { title: 'Autoroutes / interurbain', features: ['Comptage', 'Vitesse', 'Catégorisation', 'Congestion / Files'] },
        { title: 'Vélos', features: ['Comptage', 'Détection de sécurité'] },
        { title: 'Installations', features: ['Configuration / support', 'Communication sans fil (4G)'] },
      ],
    },
    // Products
    products: {
      badge: 'Nos produits phares',
      title: 'Capteurs de',
      titleHighlight: ' nouvelle génération',
      subtitle: "Des solutions adaptées à chaque besoin, des modèles basiques aux capteurs premium ultra-haute définition.",
      datasheet: 'Fiche technique PDF',
      helpTitle: "Besoin d'aide pour choisir le bon capteur ?",
      helpText: "Nous disposons de nombreux produits non visibles sur ce site pouvant être davantage adaptés à votre projet.",
      contactExperts: 'Contactez nos experts',
    },
    // Why Choose
    whyChoose: {
      badge: 'Notre engagement',
      title: 'Pourquoi choisir',
      titleHighlight: ' Smart Systems Paraguay SA ?',
      subtitle: "En tant qu'entreprise spécialisée au Paraguay, nous vous garantissons un accès à la meilleure technologie radar avec un accompagnement personnalisé.",
      benefits: [
        'Nous travaillons avec le leader mondial de la détection radar, avec plus de 180 000 capteurs déployés dans le monde entier.',
        'Nous distribuons une technologie de suivi IA Super Resolution de dernière génération pour une précision inégalée dans le comptage et la classification.',
        'Délai de livraison rapide',
        'Garantie fabricant complète',
        "Assistance à l'installation et configuration",
      ],
      items: [],
    },
    // Software
    software: {
      badge: 'Logiciel',
      title: 'Logiciel',
      titleHighlight: " d'installation",
      productName: 'Traffic UI',
      description1: 'Interface utilisateur de gestion du trafic.',
      description2: "Le logiciel Traffic UI, à la fois simple et intuitif, facilite la configuration de capteurs individuels ainsi que celle d'intersections complètes et d'installations autoroutières. L'assistant d'installation de Traffic UI facilite la planification ainsi que l'installation sur le terrain des capteurs, grâce à un guide intuitif présentant les étapes de manière séquentielle.",
    },
    // Videos
    videos: {
      badge: 'Vidéos',
      title: 'Smartmicro',
      subtitle: 'Découvrez la technologie SMARTMICRO en action à travers ces vidéos de présentation.',
      moreInfo: 'Pour plus d\'informations sur la technologie SMARTMICRO',
      visitSite: 'Visiter le site officiel SMARTMICRO',
    },
    // FAQ
    faq: {
      badge: 'FAQ',
      title: 'Questions',
      titleHighlight: ' fréquentes',
      subtitle: 'Trouvez les réponses aux questions les plus courantes sur notre technologie.',
      moreQuestions: "Vous avez d'autres questions ?",
      contactUs: 'Contactez-nous directement →',
      items: [
        { question: 'Pourquoi choisir la technologie radar plutôt que les caméras ?', answer: "Le radar offre plusieurs avantages clés : il fonctionne parfaitement dans toutes les conditions météorologiques (pluie, neige, brouillard), ne nécessite aucun éclairage, respecte totalement la vie privée des usagers car il ne capture ni visages ni plaques, ne requiert aucune maintenance et permet une portée de plus de 300 m." },
        { question: 'Quels sont les points forts des radars Doppler smartmicro ?', answer: "Les radars frontaux permettent une détection précise et fiable des usagers (voitures, vélos, piétons) grâce à un suivi de trajectoire précis et avec peu d'occlusions. Ils couvrent plusieurs voies sur de longues distances et fonctionnent efficacement dans toutes les conditions (lumière, météo). De plus, ils sont faciles à installer, non intrusifs, sans maintenance et économiques." },
        { question: "Les capteurs peuvent-ils être installés sur l'infrastructure existante ?", answer: "Oui, les capteurs peuvent être montés sur des poteaux d'éclairage existants, des feux de signalisation, des portiques ou en bordure de route, sans aucune modification de la chaussée ni travaux interrompant la circulation." },
        { question: 'Combien de voies un seul capteur peut-il couvrir ?', answer: "Selon le modèle, un seul capteur smartmicro peut couvrir de 6 à 10 voies simultanément, avec une portée allant jusqu'à 300 mètres pour les modèles longue portée." },
        { question: 'Pourquoi utiliser les radars smartmicro pour gérer les intersections ?', answer: "Ils permettent la détection de la ligne d'arrêt et des files d'attente avec un seul capteur, avec une portée allant jusqu'à 150 m ou 300 m selon le modèle. Ils offrent un suivi des objets aussi bien à l'arrêt qu'en mouvement et peuvent remplacer jusqu'à 32 boucles virtuelles par radar. De plus, ils fournissent une détection multimodale (présence, file d'attente, etc.), couvrent plusieurs voies et constituent une solution non intrusive." },
      ],
    },
    // Contact
    contact: {
      badge: 'Contact',
      title: 'Parlons de votre',
      titleHighlight: ' projet',
      subtitle: "Notre équipe est à votre disposition pour étudier vos besoins et vous proposer la solution la mieux adaptée.",
      address: 'Adresse',
      whatsapp: 'Téléphone',
      email: 'Email',
      whatsappCta: 'Contactez-nous sur WhatsApp',
      whatsappSubtext: 'Réponse rapide garantie',
      form: {
        fullName: 'Nom complet *',
        fullNamePlaceholder: 'Votre nom',
        company: 'Entreprise',
        companyPlaceholder: "Nom de l'entreprise",
        email: 'Email *',
        emailPlaceholder: 'votre@email.com',
        phone: 'Téléphone',
        phonePlaceholder: '+595...',
        message: 'Message *',
        messagePlaceholder: 'Décrivez votre projet ou vos besoins...',
        submit: 'Envoyer le message',
        submitting: 'Envoi en cours...',
        error: "Une erreur s'est produite. Veuillez réessayer.",
        success: 'Message envoyé !',
        successText: 'Nous vous répondrons dans les plus brefs délais.',
      },
    },
    // Footer
    footer: {
      description: 'Nous vous accompagnons dans la mise en place de solutions de détection de trafic de pointe pour vos projets d\'infrastructure routière.',
      navigation: 'Navigation',
      contact: 'Contact',
      rights: 'Tous droits réservés.',
      madeIn: 'Technologie',
      madeInGermany: '- Made in Germany',
    },
  },
  es: {
    // Header
    nav: {
      advantages: 'Ventajas',
      applications: 'Sensores multifuncionales',
      solutions: 'Soluciones',
      whyChoose: 'Nuestro compromiso',
      products: 'Productos',
      software: 'Software de instalación',
      videos: 'Videos SMARTMICRO',
      faq: 'FAQ',
      contact: 'Contacto',
      contactUs: 'Contáctenos',
    },
    // Hero
    hero: {
      companyName: 'Smart Systems Paraguay SA',
      badge: 'Distribuidor oficial SMARTMICRO',
      title: 'Sensores Radar Inteligentes',
      subtitle: 'para la Gestión del Tráfico',
      description: "Descubra la tecnología de detección radar más avanzada del mundo para optimizar el flujo de circulación, mejorar la seguridad vial y construir ciudades más inteligentes.",
      cta: 'Descubrir nuestras soluciones',
      trustText: 'Tecnología utilizada por ciudades de todo el mundo',
    },
    // Advantages
    advantages: {
      badge: '¿Por qué el radar?',
      title: 'Las ventajas de la tecnología',
      titleHighlight: ' SMARTMICRO',
      subtitle: "Una solución de detección superior que supera las tecnologías tradicionales en todas las condiciones.",
      items: [
        { title: 'Fiabilidad en Todo Clima', description: "Funciona perfectamente bajo lluvia, nieve, niebla, de día y de noche. La tecnología radar no se ve afectada por la suciedad, el smog o las tormentas de arena." },
        { title: 'Protección de la Privacidad', description: "A diferencia de las cámaras, los sensores radar no capturan rostros ni matrículas, garantizando total confidencialidad de los usuarios de la vía." },
        { title: 'Instalación Simple', description: "Montaje no intrusivo en infraestructura existente: postes de alumbrado, semáforos. No requiere modificación del pavimento." },
        { title: 'Precisión Ultra-Alta', description: "Tecnología 4D/UHD que permite clasificar 7 tipos de vehículos con una precisión de detección superior al 98%." },
        { title: 'Datos en Tiempo Real', description: "Transmisión instantánea de datos de tráfico para una gestión adaptativa y decisiones inmediatas." },
        { title: 'Reducción de CO2', description: "Optimización del flujo de circulación reduciendo embotellamientos y tiempos de espera, contribuyendo a la disminución de emisiones." },
      ],
      comparison: {
        title: 'Radar vs Cámaras tradicionales',
        description: "La tecnología radar ofrece una fiabilidad inigualable donde las cámaras fallan: oscuridad total, condiciones climáticas extremas y total respeto a la privacidad.",
        stats: [
          { value: '100%', label: 'Funcional de noche' },
          { value: 'IP67', label: 'Estanqueidad total' },
          { value: '-40°C', label: 'a +85°C' },
          { value: '0%', label: 'Datos personales' },
        ],
      },
    },
    // Stats
    stats: [
      { value: 'ISO 9001', label: 'Certificado' },
      { value: '27+', label: 'Años de experiencia' },
      { value: '98.4%', label: 'Precisión de detección' },
      { value: '24/7', label: 'Funcionamiento continuo' },
    ],
    // Applications
    applications: {
      badge: 'Sensores multifuncionales',
      title: 'Sensores',
      titleHighlight: ' multifuncionales',
      subtitle: "Un solo sensor SMARTMICRO puede utilizarse para múltiples aplicaciones, ofreciendo flexibilidad y retorno de inversión inigualables.",
      learnMore: 'Más información',
      items: [
        { title: 'Gestión de intersecciones', description: "", features: ['Detección combinada de stop bar y cola', 'Objetos parados y en movimiento', 'Longitud de colas', 'Smartcities'] },
        { title: 'Gestión de autopistas', description: "", features: ['Conteo y clasificación del tráfico', 'Detección de incidentes', 'Conducción errónea', 'Ramp metering', 'Túnel'] },
        { title: 'Aplicaciones de control', description: "", features: ['Control de semáforos en rojo', 'Control de velocidad', 'Control de velocidad portátil', 'Control de velocidad móvil'] },
      ],
    },
    // Solutions
    solutions: {
      badge: 'Soluciones',
      title: 'Soluciones',
      items: [
        { title: 'Ciudades', features: ['Detección para semáforos', 'Presencia', 'Contaje / Velocidad / Categorización', 'Congestión / Colas'] },
        { title: 'Autopistas / interurbano', features: ['Contaje', 'Velocidad', 'Categorización', 'Congestión / Colas'] },
        { title: 'Bicicletas', features: ['Contaje', 'Detección seguridad'] },
        { title: 'Instalaciones', features: ['Configuración / soporte', 'Comunicación inalámbrica (4G)'] },
      ],
    },
    // Products
    products: {
      badge: 'Nuestros productos estrella',
      title: 'Sensores de',
      titleHighlight: ' nueva generación',
      subtitle: "Soluciones adaptadas a cada necesidad, desde modelos básicos hasta sensores premium de ultra-alta definición.",
      datasheet: 'Ficha técnica PDF',
      helpTitle: '¿Necesita ayuda para elegir el sensor adecuado?',
      helpText: 'Disponemos de numerosos productos no visibles en este sitio que pueden adaptarse mejor a su proyecto.',
      contactExperts: 'Contacte a nuestros expertos',
    },
    // Why Choose
    whyChoose: {
      badge: 'Nuestro compromiso',
      title: 'Por qué elegir',
      titleHighlight: ' Smart Systems Paraguay SA?',
      subtitle: "Como empresa especializada en Paraguay, le garantizamos acceso a la mejor tecnología radar con acompañamiento personalizado.",
      benefits: [
        'Trabajamos con el líder mundial en detección radar, con más de 180 000 sensores desplegados en todo el mundo.',
        'Distribuimos una tecnología de seguimiento con IA Super Resolution de última generación para una precisión inigualable en el conteo y la clasificación.',
        'Plazo de entrega rápido',
        'Garantía completa del fabricante',
        'Asistencia en instalación y configuración',
      ],
      items: [],
    },
    // Software
    software: {
      badge: 'Software',
      title: 'Software',
      titleHighlight: ' de instalación',
      productName: 'Traffic UI',
      description1: 'Interfaz de usuario para gestión del tráfico.',
      description2: "El software Traffic UI, simple e intuitivo, facilita la configuración de sensores individuales así como de intersecciones completas e instalaciones en autopistas. El asistente de instalación de Traffic UI facilita la planificación e instalación en campo de los sensores, mediante una guía intuitiva que presenta los pasos de manera secuencial.",
    },
    // Videos
    videos: {
      badge: 'Videos',
      title: 'Smartmicro',
      subtitle: 'Descubra la tecnología Smartmicro en acción a través de estos videos de presentación.',
      moreInfo: 'Para más información sobre la tecnología SMARTMICRO',
      visitSite: 'Visitar el sitio oficial de SMARTMICRO',
    },
    // FAQ
    faq: {
      badge: 'FAQ',
      title: 'Preguntas',
      titleHighlight: ' frecuentes',
      subtitle: 'Encuentre las respuestas a las preguntas más comunes sobre nuestra tecnología.',
      moreQuestions: '¿Tiene más preguntas?',
      contactUs: 'Contáctenos directamente →',
      items: [
        { question: '¿Por qué elegir la tecnología radar en lugar de cámaras?', answer: "El radar ofrece varias ventajas clave: funciona perfectamente en todas las condiciones climáticas (lluvia, nieve, niebla), no necesita iluminación, respeta totalmente la privacidad de los usuarios ya que no captura rostros ni matrículas, no requiere mantenimiento y permite un alcance de más de 300 m." },
        { question: '¿Cuáles son los puntos fuertes de los radares Doppler smartmicro?', answer: "Los radares frontales permiten una detección precisa y fiable de los usuarios (coches, bicicletas, peatones) gracias a un seguimiento de trayectoria preciso y con pocas oclusiones. Cubren varios carriles a larga distancia y funcionan eficazmente en cualquier condición (luz, clima). Además, son fáciles de instalar, no intrusivos, sin mantenimiento y económicos." },
        { question: '¿Los sensores pueden instalarse en infraestructura existente?', answer: "Sí, los sensores pueden montarse en postes de alumbrado existentes, semáforos, pórticos o al borde de la carretera, sin ninguna modificación del pavimento ni obras que corten el tráfico." },
        { question: '¿Cuántos carriles puede cubrir un solo sensor?', answer: "Según el modelo, un solo sensor smartmicro puede cubrir de 6 a 10 carriles simultáneamente, con un alcance de hasta 300 metros para los modelos de largo alcance." },
        { question: '¿Por qué utilizar los radares smartmicro para gestionar intersecciones?', answer: "Permite la detección de la línea de parada y de colas con un solo sensor, con un alcance de hasta 150 m o 300 m según el modelo. Ofrece seguimiento de objetos tanto parados como en movimiento y puede sustituir hasta 32 bucles virtuales mediante radar. Además, proporciona detección multimodal (presencia, cola, etc.), cubre varios carriles y es una solución no intrusiva." },
      ],
    },
    // Contact
    contact: {
      badge: 'Contacto',
      title: 'Hablemos de su',
      titleHighlight: ' proyecto',
      subtitle: "Nuestro equipo está a su disposición para estudiar sus necesidades y proponerle la solución más adaptada.",
      address: 'Dirección',
      whatsapp: 'Teléfono',
      email: 'Email',
      whatsappCta: 'Contáctenos por WhatsApp',
      whatsappSubtext: 'Respuesta rápida garantizada',
      form: {
        fullName: 'Nombre completo *',
        fullNamePlaceholder: 'Su nombre',
        company: 'Empresa',
        companyPlaceholder: 'Nombre de la empresa',
        email: 'Email *',
        emailPlaceholder: 'su@email.com',
        phone: 'Teléfono',
        phonePlaceholder: '+595...',
        message: 'Mensaje *',
        messagePlaceholder: 'Describa su proyecto o necesidades...',
        submit: 'Enviar mensaje',
        submitting: 'Enviando...',
        error: 'Se produjo un error. Por favor, inténtelo de nuevo.',
        success: '¡Mensaje enviado!',
        successText: 'Le responderemos a la brevedad.',
      },
    },
    // Footer
    footer: {
      description: 'Le acompañamos en la implementación de soluciones de detección de tráfico de punta para sus proyectos de infraestructura vial.',
      navigation: 'Navegación',
      contact: 'Contacto',
      rights: 'Todos los derechos reservados.',
      madeIn: 'Tecnología',
      madeInGermany: '- Made in Germany',
    },
  },
  pt: {
    // Header
    nav: {
      advantages: 'Vantagens',
      applications: 'Sensores multifuncionais',
      solutions: 'Soluções',
      whyChoose: 'Nosso compromisso',
      products: 'Produtos',
      software: 'Software de instalação',
      videos: 'Vídeos SMARTMICRO',
      faq: 'FAQ',
      contact: 'Contato',
      contactUs: 'Fale Conosco',
    },
    // Hero
    hero: {
      companyName: 'Smart Systems Paraguay SA',
      badge: 'Distribuidor oficial SMARTMICRO',
      title: 'Sensores Radar Inteligentes',
      subtitle: 'para Gestão de Tráfego',
      description: "Descubra a tecnologia de detecção radar mais avançada do mundo para otimizar o fluxo de circulação, melhorar a segurança viária e construir cidades mais inteligentes.",
      cta: 'Descobrir nossas soluções',
      trustText: 'Tecnologia utilizada por cidades do mundo inteiro',
    },
    // Advantages
    advantages: {
      badge: 'Por que o radar?',
      title: 'As vantagens da tecnologia',
      titleHighlight: ' SMARTMICRO',
      subtitle: "Uma solução de detecção superior que supera as tecnologias tradicionais em todas as condições.",
      items: [
        { title: 'Confiabilidade em Qualquer Clima', description: "Funciona perfeitamente sob chuva, neve, neblina, de dia e de noite. A tecnologia radar não é afetada por sujeira, poluição ou tempestades de areia." },
        { title: 'Proteção da Privacidade', description: "Diferente das câmeras, os sensores radar não capturam rostos nem placas, garantindo total confidencialidade dos usuários da via." },
        { title: 'Instalação Simples', description: "Montagem não intrusiva em infraestrutura existente: postes de iluminação, semáforos. Nenhuma modificação no pavimento necessária." },
        { title: 'Precisão Ultra-Alta', description: "Tecnologia 4D/UHD permitindo classificar 7 tipos de veículos com precisão de detecção superior a 98%." },
        { title: 'Dados em Tempo Real', description: "Transmissão instantânea de dados de tráfego para gestão adaptativa e decisões imediatas." },
        { title: 'Redução de CO2', description: "Otimização do fluxo de circulação reduzindo congestionamentos e tempos de espera, contribuindo para a diminuição de emissões." },
      ],
      comparison: {
        title: 'Radar vs Câmeras tradicionais',
        description: "A tecnologia radar oferece confiabilidade incomparável onde as câmeras falham: escuridão total, condições climáticas extremas e total respeito à privacidade.",
        stats: [
          { value: '100%', label: 'Funcional à noite' },
          { value: 'IP67', label: 'Estanqueidade total' },
          { value: '-40°C', label: 'a +85°C' },
          { value: '0%', label: 'Dados pessoais' },
        ],
      },
    },
    // Stats
    stats: [
      { value: 'ISO 9001', label: 'Certificado' },
      { value: '27+', label: 'Anos de experiência' },
      { value: '98.4%', label: 'Precisão de detecção' },
      { value: '24/7', label: 'Funcionamento contínuo' },
    ],
    // Applications
    applications: {
      badge: 'Sensores multifuncionais',
      title: 'Sensores',
      titleHighlight: ' multifuncionais',
      subtitle: "Um único sensor SMARTMICRO pode ser utilizado para múltiplas aplicações, oferecendo flexibilidade e retorno sobre investimento incomparáveis.",
      learnMore: 'Saiba mais',
      items: [
        { title: 'Gestão de interseções', description: "", features: ['Detecção combinada de stop bar e fila', 'Objetos parados e em movimento', 'Comprimento de filas', 'Smartcities'] },
        { title: 'Gestão de rodovias', description: "", features: ['Contagem e classificação do tráfego', 'Detecção de incidentes', 'Condução errada', 'Ramp metering', 'Túnel'] },
        { title: 'Aplicações de controle', description: "", features: ['Controle de semáforos vermelhos', 'Controle de velocidade', 'Controle de velocidade portátil', 'Controle de velocidade móvel'] },
      ],
    },
    // Solutions
    solutions: {
      badge: 'Soluções',
      title: 'Soluções',
      items: [
        { title: 'Cidades', features: ['Detecção para semáforos', 'Presença', 'Contagem / Velocidade / Categorização', 'Congestionamento / Filas'] },
        { title: 'Rodovias / interurbano', features: ['Contagem', 'Velocidade', 'Categorização', 'Congestionamento / Filas'] },
        { title: 'Bicicletas', features: ['Contagem', 'Detecção de segurança'] },
        { title: 'Instalações', features: ['Configuração / suporte', 'Comunicação sem fio (4G)'] },
      ],
    },
    // Products
    products: {
      badge: 'Nossos produtos principais',
      title: 'Sensores de',
      titleHighlight: ' nova geração',
      subtitle: "Soluções adaptadas a cada necessidade, de modelos básicos a sensores premium de ultra-alta definição.",
      datasheet: 'Ficha técnica PDF',
      helpTitle: 'Precisa de ajuda para escolher o sensor certo?',
      helpText: 'Dispomos de numerosos produtos não visíveis neste site que podem ser mais adaptados ao seu projeto.',
      contactExperts: 'Contate nossos especialistas',
    },
    // Why Choose
    whyChoose: {
      badge: 'Nosso compromisso',
      title: 'Por que escolher',
      titleHighlight: ' Smart Systems Paraguay SA?',
      subtitle: "Como empresa especializada no Paraguai, garantimos acesso à melhor tecnologia radar com acompanhamento personalizado.",
      benefits: [
        'Trabalhamos com o líder mundial em detecção radar, com mais de 180 000 sensores implantados em todo o mundo.',
        'Distribuímos uma tecnologia de rastreamento com IA Super Resolution de última geração para uma precisão incomparável na contagem e classificação.',
        'Prazo de entrega rápido',
        'Garantia completa do fabricante',
        'Assistência na instalação e configuração',
      ],
      items: [],
    },
    // Software
    software: {
      badge: 'Software',
      title: 'Software',
      titleHighlight: ' de instalação',
      productName: 'Traffic UI',
      description1: 'Interface de usuário para gestão de tráfego.',
      description2: "O software Traffic UI, simples e intuitivo, facilita a configuração de sensores individuais bem como de interseções completas e instalações em rodovias. O assistente de instalação do Traffic UI facilita o planejamento e a instalação em campo dos sensores, através de um guia intuitivo apresentando as etapas de forma sequencial.",
    },
    // Videos
    videos: {
      badge: 'Vídeos',
      title: 'Smartmicro',
      subtitle: 'Descubra a tecnologia SMARTMICRO em ação através destes vídeos de apresentação.',
      moreInfo: 'Para mais informações sobre a tecnologia SMARTMICRO',
      visitSite: 'Visitar o site oficial SMARTMICRO',
    },
    // FAQ
    faq: {
      badge: 'FAQ',
      title: 'Perguntas',
      titleHighlight: ' frequentes',
      subtitle: 'Encontre as respostas para as perguntas mais comuns sobre nossa tecnologia.',
      moreQuestions: 'Tem mais perguntas?',
      contactUs: 'Contate-nos diretamente →',
      items: [
        { question: 'Por que escolher a tecnologia radar em vez de câmeras?', answer: "O radar oferece várias vantagens chave: funciona perfeitamente em todas as condições climáticas (chuva, neve, neblina), não necessita iluminação, respeita totalmente a privacidade dos usuários pois não captura rostos nem placas, não requer manutenção e permite um alcance de mais de 300 m." },
        { question: 'Quais são os pontos fortes dos radares Doppler smartmicro?', answer: "Os radares frontais permitem uma detecção precisa e confiável dos usuários (carros, bicicletas, pedestres) graças a um rastreamento de trajetória preciso e com poucas oclusões. Cobrem várias faixas a longa distância e funcionam eficazmente em qualquer condição (luz, clima). Além disso, são fáceis de instalar, não intrusivos, sem manutenção e econômicos." },
        { question: 'Os sensores podem ser instalados em infraestrutura existente?', answer: "Sim, os sensores podem ser montados em postes de iluminação existentes, semáforos, pórticos ou na beira da estrada, sem nenhuma modificação no pavimento nem obras que interrompam o tráfego." },
        { question: 'Quantas faixas um único sensor pode cobrir?', answer: "Dependendo do modelo, um único sensor smartmicro pode cobrir de 6 a 10 faixas simultaneamente, com alcance de até 300 metros para os modelos de longo alcance." },
        { question: 'Por que utilizar os radares smartmicro para gerenciar interseções?', answer: "Permite a detecção da linha de parada e de filas com um único sensor, com alcance de até 150 m ou 300 m dependendo do modelo. Oferece rastreamento de objetos tanto parados quanto em movimento e pode substituir até 32 loops virtuais por radar. Além disso, proporciona detecção multimodal (presença, fila, etc.), cobre várias faixas e é uma solução não intrusiva." },
      ],
    },
    // Contact
    contact: {
      badge: 'Contato',
      title: 'Vamos falar sobre seu',
      titleHighlight: ' projeto',
      subtitle: "Nossa equipe está à sua disposição para estudar suas necessidades e propor a solução mais adaptada.",
      address: 'Endereço',
      whatsapp: 'Telefone',
      email: 'Email',
      whatsappCta: 'Fale conosco pelo WhatsApp',
      whatsappSubtext: 'Resposta rápida garantida',
      form: {
        fullName: 'Nome completo *',
        fullNamePlaceholder: 'Seu nome',
        company: 'Empresa',
        companyPlaceholder: 'Nome da empresa',
        email: 'Email *',
        emailPlaceholder: 'seu@email.com',
        phone: 'Telefone',
        phonePlaceholder: '+595...',
        message: 'Mensagem *',
        messagePlaceholder: 'Descreva seu projeto ou necessidades...',
        submit: 'Enviar mensagem',
        submitting: 'Enviando...',
        error: 'Ocorreu um erro. Por favor, tente novamente.',
        success: 'Mensagem enviada!',
        successText: 'Responderemos o mais breve possível.',
      },
    },
    // Footer
    footer: {
      description: 'Acompanhamos você na implementação de soluções de detecção de tráfego de ponta para seus projetos de infraestrutura viária.',
      navigation: 'Navegação',
      contact: 'Contato',
      rights: 'Todos os direitos reservados.',
      madeIn: 'Tecnologia',
      madeInGermany: '- Made in Germany',
    },
  },
  en: {
    // Header
    nav: {
      advantages: 'Advantages',
      applications: 'Multifunctional sensors',
      solutions: 'Solutions',
      whyChoose: 'Our commitment',
      products: 'Products',
      software: 'Installation Software',
      videos: 'SMARTMICRO Videos',
      faq: 'FAQ',
      contact: 'Contact',
      contactUs: 'Contact Us',
    },
    // Hero
    hero: {
      companyName: 'Smart Systems Paraguay SA',
      badge: 'Official SMARTMICRO distributor',
      title: 'Intelligent Radar Sensors',
      subtitle: 'for Traffic Management',
      description: "Discover the world's most advanced radar detection technology to optimize traffic flow, improve road safety and build smarter cities.",
      cta: 'Discover our solutions',
      trustText: 'Technology used by cities around the world',
    },
    // Advantages
    advantages: {
      badge: 'Why radar?',
      title: 'The advantages of',
      titleHighlight: ' SMARTMICRO technology',
      subtitle: "A superior detection solution that outperforms traditional technologies in all conditions.",
      items: [
        { title: 'All-Weather Reliability', description: "Works perfectly in rain, snow, fog, day and night. Radar technology is not affected by dirt, smog or sandstorms." },
        { title: 'Privacy Protection', description: "Unlike cameras, radar sensors capture neither faces nor license plates, ensuring complete confidentiality for road users." },
        { title: 'Simple Installation', description: "Non-intrusive mounting on existing infrastructure: light poles, traffic lights. No road modification required." },
        { title: 'Ultra-High Precision', description: "4D/UHD technology enabling classification of 7 vehicle types with detection accuracy above 98%." },
        { title: 'Real-Time Data', description: "Instant transmission of traffic data for adaptive management and immediate decisions." },
        { title: 'CO2 Reduction', description: "Traffic flow optimization reducing congestion and waiting times, contributing to emission reduction." },
      ],
      comparison: {
        title: 'Radar vs Traditional Cameras',
        description: "Radar technology offers unmatched reliability where cameras fail: total darkness, extreme weather conditions, and complete privacy respect.",
        stats: [
          { value: '100%', label: 'Functional at night' },
          { value: 'IP67', label: 'Total sealing' },
          { value: '-40°C', label: 'to +85°C' },
          { value: '0%', label: 'Personal data' },
        ],
      },
    },
    // Stats
    stats: [
      { value: 'ISO 9001', label: 'Certified' },
      { value: '27+', label: 'Years of experience' },
      { value: '98.4%', label: 'Detection accuracy' },
      { value: '24/7', label: 'Continuous operation' },
    ],
    // Applications
    applications: {
      badge: 'Multifunctional sensors',
      title: 'Multifunctional',
      titleHighlight: ' sensors',
      subtitle: "A single SMARTMICRO sensor can be used for multiple applications, offering unmatched flexibility and return on investment.",
      learnMore: 'Learn more',
      items: [
        { title: 'Intersection management', description: "", features: ['Combined stop bar and queue detection', 'Stopped and moving objects', 'Queue length', 'Smartcities'] },
        { title: 'Highway management', description: "", features: ['Traffic counting and classification', 'Incident detection', 'Wrong-way driving', 'Ramp metering', 'Tunnel'] },
        { title: 'Control applications', description: "", features: ['Red light control', 'Speed control', 'Portable speed control', 'Mobile speed control'] },
      ],
    },
    // Solutions
    solutions: {
      badge: 'Solutions',
      title: 'Solutions',
      items: [
        { title: 'Cities', features: ['Traffic light detection', 'Presence', 'Counting / Speed / Categorization', 'Congestion / Queues'] },
        { title: 'Highways / interurban', features: ['Counting', 'Speed', 'Categorization', 'Congestion / Queues'] },
        { title: 'Bicycles', features: ['Counting', 'Safety detection'] },
        { title: 'Installations', features: ['Configuration / support', 'Wireless communication (4G)'] },
      ],
    },
    // Products
    products: {
      badge: 'Our flagship products',
      title: 'Next generation',
      titleHighlight: ' sensors',
      subtitle: "Solutions adapted to every need, from basic models to ultra-high definition premium sensors.",
      datasheet: 'PDF Datasheet',
      helpTitle: 'Need help choosing the right sensor?',
      helpText: 'We have many products not shown on this site that may be better suited to your project.',
      contactExperts: 'Contact our experts',
    },
    // Why Choose
    whyChoose: {
      badge: 'Our commitment',
      title: 'Why choose',
      titleHighlight: ' Smart Systems Paraguay SA?',
      subtitle: "As a specialized company in Paraguay, we guarantee access to the best radar technology with personalized support.",
      benefits: [
        'We work with the world leader in radar detection, with over 180,000 sensors deployed worldwide.',
        'We distribute cutting-edge Super Resolution AI tracking technology for unmatched accuracy in counting and classification.',
        'Fast delivery',
        'Full manufacturer warranty',
        'Installation and configuration assistance',
      ],
      items: [],
    },
    // Software
    software: {
      badge: 'Software',
      title: 'Installation',
      titleHighlight: ' Software',
      productName: 'Traffic UI',
      description1: 'Traffic management user interface.',
      description2: "Traffic UI software, both simple and intuitive, facilitates the configuration of individual sensors as well as complete intersections and highway installations. The Traffic UI installation wizard facilitates field planning and sensor installation through an intuitive guide presenting steps sequentially.",
    },
    // Videos
    videos: {
      badge: 'Videos',
      title: 'Smartmicro',
      subtitle: 'Discover SMARTMICRO technology in action through these presentation videos.',
      moreInfo: 'For more information about SMARTMICRO technology',
      visitSite: 'Visit the official SMARTMICRO website',
    },
    // FAQ
    faq: {
      badge: 'FAQ',
      title: 'Frequently asked',
      titleHighlight: ' questions',
      subtitle: 'Find answers to the most common questions about our technology.',
      moreQuestions: 'Have more questions?',
      contactUs: 'Contact us directly →',
      items: [
        { question: 'Why choose radar technology over cameras?', answer: "Radar offers several key advantages: it works perfectly in all weather conditions (rain, snow, fog), requires no lighting, fully respects user privacy as it captures neither faces nor plates, requires no maintenance and provides a range of over 300 m." },
        { question: 'What are the strengths of smartmicro Doppler radars?', answer: "Front radars enable accurate and reliable detection of road users (cars, bicycles, pedestrians) thanks to precise trajectory tracking with few occlusions. They cover multiple lanes over long distances and work effectively in any condition (light, weather). They are also easy to install, non-intrusive, maintenance-free and cost-effective." },
        { question: 'Can sensors be installed on existing infrastructure?', answer: "Yes, sensors can be mounted on existing light poles, traffic lights, gantries or roadside, without any pavement modification or roadwork that disrupts traffic." },
        { question: 'How many lanes can a single sensor cover?', answer: "Depending on the model, a single smartmicro sensor can cover 6 to 10 lanes simultaneously, with a range of up to 300 meters for long-range models." },
        { question: 'Why use smartmicro radars to manage intersections?', answer: "They enable stop-bar and queue detection with a single sensor, with a range of up to 150 m or 300 m depending on the model. They offer tracking of both stationary and moving objects and can replace up to 32 virtual loops via radar. They also provide multimodal detection (presence, queue, etc.), cover multiple lanes and offer a non-intrusive solution." },
      ],
    },
    // Contact
    contact: {
      badge: 'Contact',
      title: "Let's talk about your",
      titleHighlight: ' project',
      subtitle: "Our team is at your disposal to study your needs and propose the best adapted solution.",
      address: 'Address',
      whatsapp: 'Phone',
      email: 'Email',
      whatsappCta: 'Contact us on WhatsApp',
      whatsappSubtext: 'Fast response guaranteed',
      form: {
        fullName: 'Full name *',
        fullNamePlaceholder: 'Your name',
        company: 'Company',
        companyPlaceholder: 'Company name',
        email: 'Email *',
        emailPlaceholder: 'your@email.com',
        phone: 'Phone',
        phonePlaceholder: '+595...',
        message: 'Message *',
        messagePlaceholder: 'Describe your project or needs...',
        submit: 'Send message',
        submitting: 'Sending...',
        error: 'An error occurred. Please try again.',
        success: 'Message sent!',
        successText: 'We will respond as soon as possible.',
      },
    },
    // Footer
    footer: {
      description: 'We support you in implementing cutting-edge traffic detection solutions for your road infrastructure projects.',
      navigation: 'Navigation',
      contact: 'Contact',
      rights: 'All rights reserved.',
      madeIn: 'Technology',
      madeInGermany: '- Made in Germany',
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('es');

  const t = translations[currentLanguage];

  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode);
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

